
<div class="edit-page-root-container system-settings-edit-root-container" style="width:1500px;">
  <div class="page-content" style="width:700px;">
    <!-- Page header with navigation and action buttons -->
    <div class="page-header">
      <button mat-button class="nav-button" disabled>
        <img src="assets/images/menu/svg/display-order.svg" style="width: 24px;">
      </button>
      <div class="title">
        Item Discount Display Order
      </div>
      <div class="action-btn-container">
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
      </div>
    </div>
    <div class="page-details">
      <div class="detail-section general-settings">
        <form class="edit-form" *ngIf="itemClassForm" [formGroup]="itemClassForm">
          <div class="content-container">

            <div class="input-group">
              <!-- COMMENTED OUT: Menu department filter dropdown -->
              <!-- This autocomplete field was used to filter items by menu department -->
              <!-- Currently disabled - likely not needed for discount display order management -->
              <!-- <mat-form-field style="width: 500px;">
                <input matInput type="text" placeholder="Select Menu" formControlName="menu_department"
                  [matAutocomplete]="menuDeptAuto" (input)="filterMenuDepartments()" (focus)="filterMenuDepartments()">
                <button *ngIf="menuDepartmentControl.value" (click)="clearMenuDepartment()" matSuffix mat-icon-button
                  aria-label="Clear">
                  <mat-icon style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                </button>
                <mat-autocomplete [displayWith]="displayMenuDepartmentName" #menuDeptAuto="matAutocomplete">
                  <mat-option *ngFor="let dept of filteredMenuDepartments" [value]="dept">
                    <span>{{dept.name}}</span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="menuDepartmentControl.hasError('required')">
                  Please select a menu.
                </mat-error>
                <mat-error *ngIf="menuDepartmentControl.hasError('invalidMenuDepartment')">
                  Please select a valid menu from the list.
                </mat-error>
              </mat-form-field>
 -->

              <br />
              <!-- Drag & Drop Grid for reordering discount items -->
              <!-- Uses Angular CDK for drag and drop functionality -->
              <div cdkDropList cdkDropListOrientation="mixed" class="grid" (cdkDropListDropped)="drop($event)">
                <!-- Loop through itemSubClasses using Angular 17+ @for syntax -->
                @for (item of itemSubClasses; track item) {
                <!-- Each item is draggable with custom styling based on item properties -->
                <div class="item-cell" cdkDrag
                  [ngStyle]="{'background-color': item.bg_color, 'color':item.fg_color, 'width': 'calc((100% / ' + numberOfColumns + ') - 10px)'}">
                  <div class="item-code">{{ item.code }}</div>
                  <div class="item-name">{{ item.name }}</div>
                </div>
                }

              </div>
            </div>
            <!-- </div> -->

          </div>
        </form>
      </div>
    </div>
  </div>